module.exports = __webpack_public_path__ + "img/brushes-poster_en.34eefac.jpg";